import React, { FC } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { FormikValues, useFormik } from 'formik';
import { Schema } from 'yup';

import { ReactComponent as WarningIcon } from '../../../../../../assets/svg/warningIcon.svg';
import {
  Constants,
  TextFieldVariants,
} from '../../../../../../helpers/Constants';
import strings from '../../../../../../localization';
import CustomButton from '../../../../../common/CustomButton';
import CustomTextField from '../../../../../common/CustomTextField';

import Validator from './validator';
import styles from './styles';

interface IReasonDialog {
  confirmationMessage: string;
  heading: string;
  onSubmit: (values: FormikValues) => void;
  customComponent?: React.ReactNode;
  initialValues?: Record<string, string | boolean | string[]>;
  name?: string;
  validator?: null | Schema;
  primaryPress: () => void;
}

const { text } = Constants.variant;

const ReasonDialog: FC<IReasonDialog> = ({
  confirmationMessage,
  heading,
  onSubmit,
  initialValues,
  customComponent,
  validator,
  name = 'reason',
  primaryPress,
}) => {
  const defaultInitialValues = {
    reason: '',
  };

  const formik = useFormik({
    initialValues: initialValues ?? defaultInitialValues,
    onSubmit,
    validationSchema: validator === null ? null : validator ?? Validator(),
  });

  return (
    <Grid container sx={styles.girdContainer}>
      <Box sx={styles.iconContainer}>
        <WarningIcon />
      </Box>

      <Box
        sx={[styles.contentContainer, customComponent ? {} : styles.bottomGap]}
      >
        <Typography sx={styles.headingFont}>{heading}</Typography>
        <Typography sx={styles.confirmationFont}>
          {confirmationMessage}
        </Typography>
        {!!customComponent && customComponent}
      </Box>

      <Grid xs={12} item>
        <CustomTextField
          formik={formik}
          name={name}
          id={name}
          placeholder={strings.enterAReason}
          variant={TextFieldVariants.filled}
          multiline
          horizontal
        />
      </Grid>
      <Grid
        container
        sx={[styles.reasonSubmitContainer, styles.buttonContainer]}
      >
        <CustomButton
          label={strings.yes}
          onClick={formik.handleSubmit}
          variant={text}
          customButtonStyle={[styles.buttons, styles.cancelButton]}
        />
        <CustomButton
          label={strings.viewPlans}
          onClick={primaryPress}
          customButtonStyle={styles.buttons}
        />
      </Grid>
    </Grid>
  );
};

export default ReasonDialog;
